module.exports = __webpack_public_path__ + "static/media/Laidley Street, San Francisco, CA3.7978cacf.jpg";